import api from '@/api/api.js'

export default {
    // async saveResultatsAnalyse(analyseId, data) {
    //     return await api().post(`/analyses/${analyseId}/resultats`, data)
    // },

    async saveResultatsAnalyse(demande_analyse_id, data) {
        return await api().post(`/demandes-analyses/${demande_analyse_id}/resultats`, data)
    },

    // async updateResultatsAnalyse(data) {
    //     return await api().put(`/analyses/${data.analyse_id}/resultats/${data.resultat_id}`, data)
    // },

    async updateResultatsAnalyse(data) {
        return await api().put(`/resultats-analyses/${data.resultat_id}`, data)
    },
    
    async deleteResultatsAnalyse(resultatAnalyseId) {
        return await api().delete(`/resultats-analyses/${resultatAnalyseId}/delete`)
    },

    // async getResultsByAnalyseIdBulletinId(analyseId, bulletinId) {
    //     return await api().get(`/analyses/${analyseId}/bulletins/${bulletinId}/resultats`)
    // },

    async getResultsByAnalyseIdBulletinId(demande_analyse_id) {
        return await api().get(`/demandes-analyses/${demande_analyse_id}/resultats`)
    },

    async getBulletinsByPatientId(patientId) {
        return await api().get(`/patients/${patientId}/bulletins-analyses`)
    },
    
    async saveGroupedAnalyses(patientId, data) {
        return await api().post(`/patients/${patientId}/grouped-analyses`, data)
    },

    async getGroupedAnalysesByPatientId(patientId) {
        return await api().get(`/patients/${patientId}/grouped-analyses`)
    },

    async deleteGroupedAnalyse(patientId, groupedAnalyseId) {
        return await api().delete(`/patients/${patientId}/grouped-analyses/${groupedAnalyseId}`)
    },
}